import SharedPropsService from "../../SharedPropsService";
import { ROUTE } from "../../routes";
import { APPLICATION_STATE } from "../../configs/constants";
export const goHome = async (action, _datastore, { navigate, navigateToBase }) => {
    const user = await SharedPropsService.getUser();
    if (user?.linkedApplications[0]?.applicationState === APPLICATION_STATE.COMPLETED) {
        await navigate(ROUTE.DASHBOARD);
    }
    else {
        await navigateToBase(ROUTE.BORROWER_LANDING_SCREEN);
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    navigate(ROUTE.CONTACT_US_CARD);
};
